/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Pagination, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip } from '@nextui-org/react';
import { IconEdit, IconPlus, IconTrash } from '@tabler/icons-react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux'
import { SchoolService, TeacherGroupService } from '../../../../services';
import ModalCreateSubject from './create-subject';
import ModalCreateSection from './create-sections';
import { Constants } from '../../../../utils';
import Render from '../../../../components/render';

const MODAL_ACTION = {
  NONE: 0,
  CREATE: 1,
  EDIT: 2,
  DELETE: 3,
  DELETE_BY_GRADE: 4,
  CREATE_SECTION: 5
}

const Subjects = ({ filters }) => {
  const [selectedItem, setSelectedItem] = useState();
  const [modalAction, setModalAction] = useState(MODAL_ACTION.NONE);
  const { data, goToPage, isLoading, pagination, reload, deleteSubjectByGrade, user } = useFetchTable(filters);

  const onSelectItem = (item, action) => {
    setSelectedItem(item);
    setModalAction(action);
  }

  const closeModal = (reloading = false) => {
    setSelectedItem(null);
    setModalAction(MODAL_ACTION.NONE);
    if (reloading) reload();
  }

  const isFreelanceTeacher = user?.level_id === Constants.USER.LEVELS.PROFESSOR && user?.school_id === null;



  return (
    <div>
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Modal
        size="4xl"
        isOpen={modalAction !== MODAL_ACTION.NONE}
        onClose={() => closeModal(true)}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            if (modalAction === MODAL_ACTION.CREATE)
              return (
                <ModalCreateSubject
                  subjects={data}
                  onClose={onClose}
                  onSuccess={() => closeModal(true)}
                />
              );


            if (modalAction === MODAL_ACTION.EDIT)
              return (
                <ModalCreateSubject
                  item={selectedItem}
                  subjects={data}
                  onClose={onClose}
                  onSuccess={() => closeModal(true)}
                />
              );

            if (modalAction === MODAL_ACTION.DELETE_BY_GRADE)
              return (
                <ModalDeleteSubjectByGrade
                  item={selectedItem}
                  onClose={onClose}
                  onDelete={() => {
                    deleteSubjectByGrade(selectedItem?.id);
                    closeModal(true);
                  }}
                />
              )

            if (modalAction === MODAL_ACTION.CREATE_SECTION) return (
              <ModalCreateSection
                item={selectedItem}
                onClose={onClose}
                onDelete={() => {
                  closeModal(true);
                }}
              />
            )


          }}
        </ModalContent>
      </Modal>

      <Table
        aria-label="Grados"
        color="primary"
        topContentPlacement="inside"
        topContent={
          <div className="flex flex-row justify-between items-center gap-4">
            <h3 className="text-xl font-medium">Materias</h3>
            <Render condition={isFreelanceTeacher}>
              <Button
                className="pr-2 bg-green font-medium text-white"
                endContent={<IconPlus color="white" />}
                onClick={() => onSelectItem(null, MODAL_ACTION.CREATE)}
              >
                Nuevo
              </Button>
            </Render>
          </div>
        }
      >
        <TableHeader>
          <TableColumn hidden></TableColumn>
        </TableHeader>
        <TableBody items={data} emptyContent="No hay resultados">
          {(item) => (
            <TableRow>
              <TableCell colSpan={4} className="p-0 bg-default-100 rounded-xl overflow-hidden">
                <div className="bg-default-100 text-foreground-500 py-2 px-3 text-lg font-medium flex flex-row justify-between">
                  <span>{item.name}</span>
                  <div className='flex items-center gap-2'>
                    <Render condition={isFreelanceTeacher}>
                      <Tooltip content="Editar">
                        <IconEdit onClick={() => onSelectItem({ subjects: item?.subjects, school_grade_id: item.id, school_year_id: item.school_year_id }, MODAL_ACTION.EDIT)} />
                      </Tooltip>
                      <Tooltip content="Eliminar grado" color="danger">
                        <IconTrash className="text-danger" onClick={() => onSelectItem(item, MODAL_ACTION.DELETE_BY_GRADE)} />
                      </Tooltip>
                    </Render>
                  </div>
                </div>
                <Table
                  aria-label="Materias"
                  classNames={{ wrapper: 'p-0 border-0 shadow-none' }}
                >
                  <TableHeader>
                    <TableColumn>Nombre</TableColumn>
                    <TableColumn>Código</TableColumn>
                    <TableColumn>Secciones</TableColumn>
                    <TableColumn>Horario/Semanal</TableColumn>
                    <TableColumn>Calificación</TableColumn>
                  </TableHeader>
                  <TableBody items={item?.subjects ?? []} emptyContent="No hay materias">
                    {(subject) => (
                      <TableRow key={subject.id}>
                        <TableCell>{subject.name}</TableCell>
                        <TableCell>{subject.code}</TableCell>
                        <TableCell>{item?.sections?.map(x => x.name).sort().join(', ')}</TableCell>
                        <TableCell>{subject.hours}</TableCell>
                        <TableCell>
                          {
                            subject.type_qualification == Constants.SUBJECTS.TYPE_QUALIFICATION.QUALITATIVE ? 'Cualitativa'
                              : subject.type_qualification == Constants.SUBJECTS.TYPE_QUALIFICATION.QUANTITATIVE ? 'Cuantitativa' : ''
                          }
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>


      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
}

const ModalDeleteSubjectByGrade = ({ item, onClose, onDelete }) => {
  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de eliminar las materias de este grado?. Puede que posea registros de horarios asociados, al eliminarse se eliminarán también dichos registros</p>
        <p className="text-center font-medium">{item.name}</p>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="danger" onPress={onDelete}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}

const useFetchTable = (parentFilters) => {
  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: 10,
  };


  const initialFilters = {
    page: 1,
    perPage: 10,
    ...parentFilters
  };

  const user = useSelector((state) => state.user)
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);


  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const response = await TeacherGroupService.groups.getSubjects({ ...filters, professor_id: user.id })
      const { data, ...rest } = response;
      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const deleteSubjectByGrade = async (id) => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      await TeacherGroupService.groups.deleteSubjectByGrade({ id });
      toast.success('Materias eliminadas con éxito');
      fetchData();

    } catch (error) {
      onError(String(error));
    }
    setCanFetch(true);
  }

  const getCurrentPagination = () => {
    // Truco para obtener el estado actualizado (pagination es mantenida con el estado actual por el componente Pagination)
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }



  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    setFilters((s) => ({ ...s, ...parentFilters }))
  }, [parentFilters])

  return {
    changePerPage,
    data,
    goToPage,
    isLoading: !canFetch,
    pagination,
    reload,
    deleteSubjectByGrade,
    user
  }
}

export default Subjects;
